__webpack_require__.p = "https://stdatavisualprod.blob.core.windows.net/$web/projects/25/voices-of-the-brave/";